let state = {
    url: ''
};
export default state;


// WEBPACK FOOTER //
// ./src/vuex/modules/baseUrl/state.js